import { ConsistentMapSchema, } from "@referee-fyi/consistency";
import { z } from "zod/v4";
import { IncidentSchema } from "./incident.js";
import { MatchScratchpadSchema } from "./scratchpad.js";
import { InvitationSchema } from "./server.js";
export const UserRole = ["none", "system"];
export const UserSchema = z
    .object({
    key: z.string(),
    name: z.string(),
    role: z.enum(UserRole),
})
    .meta({
    id: "User",
    description: "A registered user",
});
export const UserInvitationSchema = InvitationSchema.pick({
    id: true,
    admin: true,
    accepted: true,
    sku: true,
}).extend({
    from: UserSchema,
});
export const InvitationListItemSchema = z
    .object({
    admin: z.boolean(),
    user: UserSchema,
})
    .meta({
    id: "InvitationListItem",
    description: "Represents a user who has access to a shared instance.",
});
export const InstanceIncidentsSchema = ConsistentMapSchema(IncidentSchema);
export const InstanceScratchpadSchema = ConsistentMapSchema(MatchScratchpadSchema);
// WebSocket communications
export const WebSocketAddIncidentMessageSchema = z.object({
    type: z.literal("add_incident"),
    incident: IncidentSchema,
});
export const WebSocketUpdateIncidentMessageSchema = z.object({
    type: z.literal("update_incident"),
    incident: IncidentSchema,
});
export const WebSocketRemoveIncidentMessageSchema = z.object({
    type: z.literal("remove_incident"),
    id: z.string(),
});
export const WebSocketUpdateScratchpadMessageSchema = z.object({
    type: z.literal("scratchpad_update"),
    id: z.string(),
    scratchpad: MatchScratchpadSchema,
});
export const WebSocketBroadcastMessageSchema = z.object({
    type: z.literal("message"),
    message: z.string(),
});
export const WebSocketPeerMessageSchema = z.discriminatedUnion("type", [
    WebSocketAddIncidentMessageSchema,
    WebSocketUpdateIncidentMessageSchema,
    WebSocketRemoveIncidentMessageSchema,
    WebSocketUpdateScratchpadMessageSchema,
    WebSocketBroadcastMessageSchema,
]);
export const WebSocketServerShareInfoMessageSchema = z.object({
    type: z.literal("server_share_info"),
    sku: z.string(),
    incidents: InstanceIncidentsSchema,
    scratchpads: InstanceScratchpadSchema,
    users: z.object({
        active: z.array(UserSchema),
        invitations: z.array(InvitationListItemSchema),
    }),
});
export const WebsocketServerUserAddMessageSchema = z.object({
    type: z.literal("server_user_add"),
    user: UserSchema,
    activeUsers: z.array(UserSchema),
    invitations: z.array(InvitationListItemSchema),
});
export const WebsocketServerUserRemoveMessageSchema = z.object({
    type: z.literal("server_user_remove"),
    user: UserSchema,
    activeUsers: z.array(UserSchema),
    invitations: z.array(InvitationListItemSchema),
});
export const WebSocketServerErrorMessageSchema = z.object({
    type: z.literal("server_error"),
    error: z.string(),
});
export const WebSocketServerMessageSchema = z.discriminatedUnion("type", [
    WebSocketServerShareInfoMessageSchema,
    WebsocketServerUserAddMessageSchema,
    WebsocketServerUserRemoveMessageSchema,
    WebSocketServerErrorMessageSchema,
]);
export const WebSocketMessageSchema = z.union([
    WebSocketPeerMessageSchema,
    WebSocketServerMessageSchema,
]);
export const WebSocketSenderSchema = z.union([
    z.object({ type: z.literal("server") }),
    z.object({ type: z.literal("client"), name: z.string(), id: z.string() }),
]);
export const WebSocketPayloadAdditionalInfoSchema = z.object({
    date: z.string().meta({ description: "ISO-8601 String" }), // ISO string
    sender: WebSocketSenderSchema,
});
export const WebSocketPayloadSchema = (type) => WebSocketPayloadAdditionalInfoSchema.extend(type);
//# sourceMappingURL=api.js.map